import { WidgetContactFormFieldType } from 'widget/entities/config';
import FormFieldModel from 'widget/models/FormFieldModel';
import type { FieldValidator } from 'widget/utils/validators';

export type ContactFieldModelParams = {
  type: WidgetContactFormFieldType;
  required: boolean;
  validators?: FieldValidator<string>[];
};

export default class ContactFieldModel {
  readonly formField: FormFieldModel<string>;
  readonly required: boolean;
  readonly type: WidgetContactFormFieldType;

  constructor(params: ContactFieldModelParams) {
    this.type = params.type;
    this.required = params.required;
    this.formField = new FormFieldModel<string>('', {
      validators: params.validators
    });
  }

  get value(): string {
    return this.formField.value;
  }

  get error(): string | null {
    return this.formField.error;
  }

  get isValid(): boolean {
    return this.formField.isValid;
  }
}
